jQuery(function ($) {
    /**
     * Hamburger menu icon.
     */
    $("input#menu-btn").on('change', function () {
        if (this.checked) {
            $('body').addClass("lock-scroll")
            $('.main-menu').slideDown(500);
        }
        else {
            $('.main-menu').slideUp(500);
            $('body').removeClass("lock-scroll")
        }
    });

    let is_desktop = window.innerWidth > 1024;
    window.onresize = function () {
        const current_mode = window.innerWidth > 1024;
        if (current_mode && !is_desktop) {
            $('.main-menu').css("display", "flex");
            $('header').siblings().removeClass('d-none');
            $('header').parents().siblings().removeClass('d-none');
            $('body').css('overflow-x', 'hidden');
            $('html').css('overflow-x', 'hidden');
            is_desktop = !is_desktop;
        }
        else if (!current_mode && is_desktop) {
            $('.main-menu').css("display", "none");
            $('#menu-btn').attr('checked', false);
            is_desktop = !is_desktop;
        }
    }
})